import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from '../fgi-back-end.service';
import { useCache } from "@bndes/bndes-ux4/bndes-angular-utils";
import moment from "moment";

@Injectable({ 
  providedIn: 'root'
}) 
export class DataSistemaService extends FgiBackEndService<any> {

   // @Override
   getNewEntity() {
    // o servico sera apenas para leitura
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return undefined;
  }

  // nao tem no BaseEntityService pra fazer override

  getDataCorrente() {
    return this.getDataCorrenteStr().pipe(map(dataCorrenteStr => moment(dataCorrenteStr, 'DD-MM-YYYY').toDate()));
  }

  getDataCorrenteStr() {
    return this.http.get(`rest/front/data-sistema`, { responseType: 'text' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  getTimeStampISO() {
    return this.http.get(`rest/front/data-sistema/ISO`, useCache()).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

}